/**
 * 页面滚动锁（引用计数版）
 *
 * 背景：Shop/Manage 下的弹窗组件（发货、售后各操作弹窗、提现等）都是
 * `position:fixed` 的全屏遮罩，自身不带滚动锁。在弹窗内滚动到边界后，
 * 浏览器的滚动链（scroll chaining）会把滚动事件继续抛给 body，
 * 表现为「弹窗里滚到底之后，后面的页面跟着滚」。
 *
 * 之所以用引用计数：index.vue 里多个弹窗可能叠加打开（例如发货弹窗里再开物流弹窗），
 * 若直接 `body.style.overflow = 'hidden'` / `''`，先关的那个弹窗会把锁解掉，
 * 导致仍打开的弹窗失去锁定。计数为 0 时才真正恢复。
 */

let lock_count = 0;
let saved_overflow = '';
let saved_padding_right = '';

/** 取当前纵向滚动条宽度（无滚动条时为 0） */
function getScrollbarWidth() {
    return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

/** 加锁：弹窗打开时调用 */
export function lockScroll() {
    if (lock_count === 0) {
        const body = document.body;
        saved_overflow = body.style.overflow;
        saved_padding_right = body.style.paddingRight;

        const scrollbar_width = getScrollbarWidth();
        body.style.overflow = 'hidden';
        // 补上滚动条宽度，避免锁定瞬间页面横向跳动
        if (scrollbar_width > 0) {
            const current_padding = parseInt(window.getComputedStyle(body).paddingRight, 10) || 0;
            body.style.paddingRight = `${current_padding + scrollbar_width}px`;
        }
    }
    lock_count += 1;
}

/** 解锁：弹窗关闭时调用（必须与 lockScroll 成对） */
export function unlockScroll() {
    if (lock_count === 0) return;
    lock_count -= 1;
    if (lock_count === 0) {
        document.body.style.overflow = saved_overflow;
        document.body.style.paddingRight = saved_padding_right;
    }
}

/** 强制解锁（路由离开/组件销毁兜底用，避免 body 永久锁死） */
export function forceUnlockScroll() {
    if (lock_count === 0) return;
    lock_count = 0;
    document.body.style.overflow = saved_overflow;
    document.body.style.paddingRight = saved_padding_right;
}
